import { render } from "./BillList.vue?vue&type=template&id=4ac5c256&scoped=true"
import script from "./BillList.vue?vue&type=script&lang=js"
export * from "./BillList.vue?vue&type=script&lang=js"

import "./BillList.vue?vue&type=style&index=0&id=4ac5c256&scoped=true&lang=css"

import exportComponent from "D:\\cwzl\\four-cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ac5c256"]])

export default __exports__